import EditIcon from "@mui/icons-material/Edit";
import { IconButton } from "@mui/material";
import { useCallback } from "react";
import { useDialogBetter } from "../../../hooks/useDialogBetter";
import {
    EmailFooterConfigurationDialog,
    EmailFooterConfigurationDialogMode,
} from "./EmailFooterConfigurationDialog";

export const EditEmailFooterButton = (props) => {
    const { emailFooter, sellerId, onSuccess } = props;

    const { openDialog } = useDialogBetter();

    const handleClick = useCallback(
        () =>
            openDialog({
                Component: EmailFooterConfigurationDialog,
                componentProps: {
                    sellerId,
                    onSuccess,
                    initialEmailFooter: emailFooter,
                    mode: EmailFooterConfigurationDialogMode.EDIT,
                },
            }),
        [openDialog, sellerId, onSuccess, emailFooter],
    );

    return (
        <IconButton onClick={handleClick}>
            <EditIcon />
        </IconButton>
    );
};
